export const SKAPIEC_AGREEMENT_URL = 'https://panel.onetads.pl/static/skapiec/regulamin.pdf';
